<template lang="pug">
w-select.f-select(
  :value='items'
  v-bind=`{ label, single, readonly, disabled, optionDescription }`
  :options='thisOptions'
  @input='updateItems'
)
  template( v-for='(_, name) in $scopedSlots' #[name]='scope' )
    slot( :name="name" v-bind='scope')
</template>

<script lang="js">
import isArray from 'lodash-es/isArray'
import isNumber from 'lodash-es/isNumber'
import isString from 'lodash-es/isString'
import { mapState, mapActions } from 'vuex'
import WSelect from '@/widgets/w-select'

export default {
  name: 'SelectField',
  mixins: [],
  components: { WSelect },
  props: {
    label: {
      type: String,
      default: 'Users'
    },
    value: {
      type: [ Number, Object, Array, String ],
      default: () => []
    },
    selected: {
      type: [ Number, Object, Array, String ],
      default: () => []
    },
    options: {
      type: Array,
      required: true,
    },
    optionDescription: {
      type: String,
      default: ''
    },
    single: Boolean,
    disabled: Boolean,
  },
  data() {
    return {
      items: []
    }
  },
  created() {
    this.setItems( this.selected, this.value )
  },
  mounted() {},
  methods: {
    setItems( selected, value ) {
      if ( this.single ) {
        return this.setItem( selected, value )
      }
      const items = []
      const seen = {}
      if ( !isArray( selected )) {
        selected = selected ? [ selected ] : []
      }
      if ( !isArray( value )) {
        value = value ? [ value ] : []
      }
      for ( const s of selected ) {
        const id = isNumber(s) || isString(s) ? s : s.id
        const item = this.itemMap[ id ]
        if ( item ) {
          items.push( item )
          seen[ id ] = item
        }
      }
      for ( const v of value ) {
        const id = isNumber(v) || isString(v) ? v : v.id
        const item = this.itemMap[ id ]
        if ( item && !seen[ id ]) {
          items.push( item )
          seen[ id ] = item
        }
      }
      this.items = items
      return items
    },
    setItem( selected, value ) {
      if ( selected ) {
        if ( isArray( selected )) {
          selected = selected[0]
        }
        if ( isNumber( selected ) || isString( selected )) {
          const item = this.itemMap[ selected ]
          if ( item ) {
            this.items = item
            return item
          }
        } else if ( selected ) {
          this.items = selected
          return selected
        }
      }
      if ( value ) {
        if ( isArray( value )) {
          value = value[0]
        }
        if ( isNumber( value ) || isString( value )) {
          const item = this.itemMap[ value ]
          if ( item ) {
            this.items = item
            return item
          }
        } else {
          this.items = value
          return value
        }
      }
    },
    updateItems( items ) {
      this.items = items
      this.$emit( 'input', items )
    }
  },
  computed: {
    readonly() {
      return !!( this.single ? this.selected : this.selected.length )
    },
    itemMap() {
      const out = {}
      for ( const o of this.thisOptions ) {
        out[ o.id ] = o
      }
      return out
    },
    thisOptions() {
      return this.options.map( o => (
        isString(o)
           ? { id: o, name: o }
        : o
      ))
    }
  },
  watch: {
    value( items ) {
      this.setItems( this.selected, items )
    },
    selected( items ) {
      this.setItems( items, this.value )
    },
    options() {
      this.setItems( this.selected, this.value )
    }
  }
}
</script>

<style lang="scss">
.f-select {

}
</style>
